module.exports = __webpack_public_path__ + "img/zhyd.71449d59.png";